<template>
  <div class='exportreport_cell'>
    <v-btn icon @click="download()" :disabled='isDownloadDisabled'>
      <v-icon large color="#8F24D3" :class="{'material-icons-outlined':(true)}"> file_download </v-icon>
    </v-btn>
  </div>
</template>

<script>
import { downloadScanDataReport } from '@/services/repository';

export default {
  name: 'ProjectExportScanTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    isDownloadDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    async download() {
      const dataStream = await this.getStreamData();
      const blob = new Blob([dataStream], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', 'report.txt');
      document.body.appendChild(link);
      link.click();
    },
    async getStreamData() {
      const payload = {
        projectId: this.item.projectId,
        scanDataId: this.item.id,
      };
      const url = await downloadScanDataReport(payload);
      return url;
    },
  },
};
</script>

<style lang="scss" scoped>
.exportreport_cell{
  text-align: center;
  margin-left: -5px;
}
</style>
